import { useEffect } from "react";
import { CONTACT } from "../utils/contact";
import "./ACRateListModal.css";

const RATE_CATEGORIES = [
  {
    title: "Inspection & Maintenance",
    items: [
      { service: "Diagnostic / Inspection Visit", price: 800 },
      { service: "General Master Service", price: 2200 },
      { service: "Deep Chemical Wash", price: 2800 },
    ],
  },
  {
    title: "Installation & Relocation",
    items: [
      { service: "Standard AC Installation", price: 2800 },
      { service: "Same Building Relocation", price: 3500 },
      { service: "Re Installation Only", price: 4000 },
      { service: "Additional Piping Labor (Per Foot)", price: 100 },
    ],
  },
  {
    title: "Priority & Urgent",
    items: [
      { service: "Same Day Priority Dispatch", price: 500 },
      { service: "After Hours Urgent Service", price: 800 },
      { service: "Weekend / Gazette Holiday", price: 1000 },
    ],
  },
];

function formatPrice(amount) {
  return amount.toLocaleString("en-PK");
}

export default function ACRateListModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="ac-rate-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ac-rate-title"
      onClick={onClose}
    >
      <div className="ac-rate-panel" onClick={(e) => e.stopPropagation()}>
        <div className="ac-rate-hero">
          <div className="ac-rate-hero-glow" aria-hidden="true" />
          <button
            type="button"
            className="ac-rate-close"
            onClick={onClose}
            aria-label="Close rate list"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
            </svg>
          </button>

          <div className="ac-rate-hero-content">
            <div className="ac-rate-hero-icon" aria-hidden="true">❄️</div>
            <div>
              <span className="ac-rate-brand">Maskanh AC Technician</span>
              <h2 id="ac-rate-title">Official Rate List</h2>
              <p>Kamra &amp; Attock · Verified technicians · No hidden charges</p>
            </div>
          </div>

          <div className="ac-rate-highlights">
            <div>
              <strong>10+</strong>
              <span>Services</span>
            </div>
            <div>
              <strong>30 min</strong>
              <span>WhatsApp confirm</span>
            </div>
            <div>
              <strong>PKR</strong>
              <span>Fixed rates</span>
            </div>
          </div>
        </div>

        <div className="ac-rate-body">
          {RATE_CATEGORIES.map((category) => (
            <section key={category.title} className="ac-rate-group">
              <header className="ac-rate-group-head">
                <span className="ac-rate-group-icon" aria-hidden="true">
                  {category.icon}
                </span>
                <h3>{category.title}</h3>
              </header>

              <ul className="ac-rate-list">
                {category.items.map((item) => (
                  <li key={item.service} className="ac-rate-item">
                    <div className="ac-rate-item-info">
                      <span className="ac-rate-item-dot" aria-hidden="true" />
                      <span className="ac-rate-item-name">{item.service}</span>
                    </div>
                    <div className="ac-rate-item-price">
                      <span className="ac-rate-currency">PKR</span>
                      <span className="ac-rate-amount">{formatPrice(item.price)}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <footer className="ac-rate-footer">
          <p>
            Prices may vary by AC tonnage, parts &amp; onsite conditions.
            Final quote confirmed on WhatsApp before work starts.
          </p>
          <a
            href={CONTACT.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary ac-rate-whatsapp"
            onClick={onClose}
          >
            Book on WhatsApp
          </a>
        </footer>
      </div>
    </div>
  );
}
